import echo from "@/echo/echo";
import { hasSessionToken } from "@/utils/session";

let nombreCanalCredito = null;

export function suscribirACanalCredito(onCreditUpdated) {
  if (!hasSessionToken()) return false;

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch (error) {
    console.error("No se pudo leer el usuario para suscribir el canal de crédito", error);
    return false;
  }

  if (!user?.id) return false;

  const nombreDeCanal = `users.${user.id}.credit`;

  if (nombreCanalCredito === nombreDeCanal) return true;
  dejarCanalCredito();

  nombreCanalCredito = nombreDeCanal;

  echo
    .private(nombreDeCanal)
    .subscribed(() => {})
    .error((error) => {
      console.error("Error autorizando canal privado de crédito:", error);
    })
    .listen(".CreditUpdated", (event) => {
      console.log("[creditChannel] CreditUpdated received", event);
      if (event?.summary) {
        console.log("[creditChannel] calling onCreditUpdated", event.summary);
        onCreditUpdated(event.summary);
      }
    });

  return true;
}

export function dejarCanalCredito() {
  if (!nombreCanalCredito) return;

  echo.leave(nombreCanalCredito);
  nombreCanalCredito = null;
}
